
export * from '../../frontend-js-react-web/__liferay__/exports/react-dnd.js';

import __default__ from '../../frontend-js-react-web/__liferay__/exports/react-dnd.js';
export default __default__;
